<template>
  <div>
    <b-jumbotron :lead="$t('label.bo_change_password')" />
    <div class="login">
      <template>
        <h3 class="title">{{ $t("label.password_update") }}</h3>
        <b-form-group
          id="g_input-password_old"
          v-if="!forgotedpwd"
          :label="$t('label.password_old')"
          label-for="input-password_old"
        >
          <b-form-input
            id="input-password_old"
            v-model="formData.oldPwd"
            type="password"
            required
          />
        </b-form-group>
        <b-form-group
          id="g_input-password"
          :label="$t('label.password_new')"
          label-for="input-password_new"
        >
          <b-form-input
            id="input-password_new"
            v-model="formData.newPwd"
            type="password"
            :state="isValid"
            required
          />
        </b-form-group>
        <b-form-group
          id="g_input-password_confirm"
          :label="$t('label.password_confirm')"
          label-for="input-password_confirm"
        >
          <b-form-input
            id="input-password_confirm"
            v-model="formData.confirmPwd"
            type="password"
            :state="isMatchValid"
            required
          />
          <div class="error" v-if="formData.confirmPwd !== '' && !isMatchValid">
            {{ $t("error.no_match_password") }}
          </div>
        </b-form-group>
        <b-row class="mt-3 bd-callout" v-if="true && policyCriteria" >
          <b-col>
            <b-alert variant="blue" :show="!isValidPassword">
              <b-row align-v="center" >
                <b-col cols="auto">
                  <font-awesome-icon
                    :icon="['fas', 'info']"
                    class="icon"
                  />
                </b-col>
                <b-col>
                  <span>{{ $t("alert.password.info") }}</span>
                  <ul>
                    <li :style="getColorPwdRule(state.pwdLengthOk)">
                      {{
                        policyCriteria.size.max
                          ? $t("alert.password.lenght_with_max", [
                              policyCriteria.size.min,
                              policyCriteria.size.max,
                            ])
                          : $t("alert.password.info_lenght", [
                              policyCriteria.size.min,
                            ])
                      }}
                    </li>
                    <li
                      v-if="policyCriteria.char.upper.authorized"
                      :style="getColorPwdRule(state.pwdUpperOk)"
                    >
                      {{
                        policyCriteria.char.upper.max
                          ? $t("alert.password.info_upper_char_with_max", [
                              policyCriteria.char.upper.min,
                              policyCriteria.char.upper.max,
                            ])
                          : $t("alert.password.info_upper_char", [
                              policyCriteria.char.upper.min,
                            ])
                      }}
                    </li>
                    <li
                      v-if="policyCriteria.char.lower.authorized"
                      :style="getColorPwdRule(state.pwdLowerOk)"
                    >
                      {{
                        policyCriteria.char.lower.max
                          ? $t("alert.password.info_lower_char_with_max", [
                              policyCriteria.char.lower.min,
                              policyCriteria.char.lower.max,
                            ])
                          : $t("alert.password.info_lower_char", [
                              policyCriteria.char.lower.min,
                            ])
                      }}
                    </li>
                    <li
                      v-if="policyCriteria.number.authorized"
                      :style="getColorPwdRule(state.pwdNumberOk)"
                    >
                      {{
                        policyCriteria.number.max
                          ? $t("alert.password.info_number_with_max", [
                              policyCriteria.number.min,
                              policyCriteria.number.max,
                            ])
                          : $t("alert.password.info_number", [
                              policyCriteria.number.min,
                            ])
                      }}
                    </li>
                    <li
                      v-if="policyCriteria.special.authorized"
                      :style="getColorPwdRule(state.pwdSpecialOk)"
                    >
                      {{ getSpecialPasswordText }}
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </b-alert>
          </b-col>
        </b-row>
        <b-container>
          <b-row>
            <b-col>
              <b-button
                :variant="isValidPassword ? 'primary' : 'secondary'"
                :title="$t('btn.reset')"
                :disabled="!isValidPassword"
                @click.prevent="changePwd()"
                >{{ $t("btn.reset") }}</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </template>
    </div>
  </div>
</template>

<script>
import {
  getPolicyCriteria,
  PasswordChange,
  PasswordValidateReset,
} from "../services/account";
import { passwordCompliance } from "../misc/checkpwd";
import { clear } from "../storage";
export default {
  data() {
    return {
      formData: {
        login: "",
        password: "",
        newPwd: "",
        confirmPwd: "",
        oldPwd: "",
      },
      policyCriteria: null,
      forgotedpwd: false,
      submitEnabled: false,
      state: {
        pwdLengthOk: false,
        pwdUpperOk: false,
        pwdLowerOk: false,
        pwdNumberOk: false,
        pwdSpecialOk: false,
      },
    };
  },
  watch: {
    formData: {
      handler() {
        this.submitEnabled = this.isValidPassword;
      },
      deep: true,
    },
    "formData.newPwd": {
      handler(val) {
        if (this.policyCriteria)
          this.state = passwordCompliance(this.policyCriteria, val);
      },
    },
  },
  async mounted() {
    // s'il s'agit d'un token de réinitialisation
    if (this.$route.query.tpw) {
      this.forgotedpwd = true
      if (await PasswordValidateReset(this.$route.query.tpw)){
        this.policyCriteria = await getPolicyCriteria();
      }
      else { // si expiré on retourne au login
        this.showToast("danger", this.$t("msg.text.invalid_link"), this.$t("msg.title.reset_password"));
        setTimeout(() =>  this.$router.toLogin(), 6000);
      }
    } else {
      this.$router.toLogin();
    }
  },
  computed: {
    isMatchValid() {
      return (
        this.formData.confirmPwd !== "" &&
        this.formData.newPwd === this.formData.confirmPwd
      );
    },
    isValid(){
      return (
        this.state.pwdLengthOk &&
        this.state.pwdSpecialOk &&
        this.state.pwdNumberOk &&
        this.state.pwdUpperOk &&
        this.state.pwdLowerOk        
      );
    },
    isValidPassword() {
      return ( this.isValid && this.isMatchValid );
    },
    getSpecialPasswordText() {
      const authSpecial = this.policyCriteria.special.include.join("");

      if (this.policyCriteria.special.max) {
        return this.$t("alert.password.info_specials_with_max", [
          this.policyCriteria.special.min,
          this.policyCriteria.special.max,
          authSpecial,
        ]);
      }
      return this.policyCriteria.special.min > 1
        ? this.$t("alert.password.info_specials", [
            this.policyCriteria.special.min,
            authSpecial,
          ])
        : this.$t("alert.password.info_special", [
            this.policyCriteria.special.min,
            authSpecial,
          ]);
    },
  },
  methods: {
    getColorPwdRule(isOk) {
      return `color: ${isOk ? "green" : "red"}`;
    },
    async changePwd() {
      try {
        const params = {
          newPassword: this.formData.newPwd,
          confirmNewPassword: this.formData.confirmPwd,
          resetToken: this.$route.query.tpw 
        };
        const res = await PasswordChange(params);
        if (res) {
          this.showToast(
            "success",
            this.$t("msg.text.success_password_reset"),
            this.$t("msg.title.reset_password")
          );
          clear();
          setTimeout(() => this.$router.toLogin(), 6000);
        }
      } catch (err) {
        let text;
        const msg = err.response?.data;
        switch (msg) {
          case "OLD_PASSWORD_IS_NEW_PASSWORD":
            text = this.$t("msg.text.old_password_is_new_password");
            break;
          case "PASSWORD_MISMATCH":
            text = this.$t("msg.text.password_mismatch");
            break;
          case "OLD_PASSWORD_INVALID":
            text = this.$t("msg.text.old_password_invalid");
            break;
          case "INVALID_LINK":
            text = this.$t("msg.text.invalid_link");
            break;
          default:
            text = this.$t("msg.text.error_general");
        }
        this.showToast("danger", text, this.$t("msg.title.reset_password"));
      }
    },
  },
};
</script>

<style lang="css" scoped>
.background {
  height: 100%;
  background-repeat: no-repeat;
}

.login {
  width: 70vw;
  max-width: 800px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.8);
}

.title,
.btnZone {
  text-align: center;
}

.border-red {
  border: 1px solid red;
}

.error {
  color: red;
  font-size: 0.8rem;
}
.bd-callout {
  padding: 1.25rem;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid #eee;
  border-left-width: 0.5rem;
  border-radius: 0.5rem;
  border-left-color: #007bff;
}

ul {
  list-style: disc;
  margin-left: 30px;
}
ul.li {
    display: list-item;
}

.icon
{
  position : relative;
  display : inline-block;
  vertical-align : middle;
  color: #007bff;
  width: 32px;
  height: 32px;
}
</style>
